import React, { useState } from "react";

import { useAppDispatch } from "../../../../../src/app/hooks";
import StageWorkflowReturnCaseModal from "../../../../../src/features/stageWorkflow/components/StageWorkflowReturnCaseModal";
import { AddStageRequest, CaseStageAction, CaseStageEnum } from "../../../../../src/api/caseStages";
import { useParams } from "react-router-dom";
import { updateCaseStage } from "../../logic/thunks";
import { showErrorToast, showSuccessToast } from "../../../../../src/lib/toast";
import { ReturnButton } from "../../../../../src/components/ui/button/v2/ReturnButton";



export const ReturnCaseWithInfo: React.FC<{
  next_stage: CaseStageEnum
}> = ({next_stage}) => {
  const dispatch = useAppDispatch();
  const { id: caseId } = useParams<{ id: string }>();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpen = (): void => {
    setIsModalOpen(true);
  };

  const handleClose = (): void => {
    if (isLoading) return;
    setIsModalOpen(false);
  };

  const handleReturnCase = async (additionalInfo: string) => {
  if (!caseId) {
    return;
  }

  try {
    setIsLoading(true);

    const request: AddStageRequest = {
      stage: next_stage,
      source_action: CaseStageAction.RETURN_CASE_WITH_INFO,
      stage_data: {
        notes: additionalInfo,
      },
    };

    await dispatch(
      updateCaseStage({
        caseId,
        request,
      })
    ).unwrap();

    showSuccessToast("Case returned successfully");

    setIsModalOpen(false);
  } catch (error) {
    showErrorToast("Failed to return case");
  } finally {
    setIsLoading(false);
  }
};

  return (
    <>
      <ReturnButton
        label="Return"
        onClick={handleOpen}
      />

      <StageWorkflowReturnCaseModal
        isOpen={isModalOpen}
        onClose={handleClose}
        onReturnCase={handleReturnCase}
        loading={isLoading} 
      />
    </>
  );
};